import script from "./GameGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameGrid.vue?vue&type=script&setup=true&lang=ts"

import "./GameGrid.vue?vue&type=style&index=0&id=50e632f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e632f6"]])

export default __exports__